import React from 'react';
import AccessCard from 'components/AccessCard';
import { useRouteMatch } from 'react-router';
import { ROUTES } from 'constants/routes';
import SectionBasePage from 'components/SectionBasePage';
import { Icons } from 'UI';
import { useBreadcrumbNavigation, useRootPage } from 'hooks/breadcrumb';
import { usePermissions } from 'hooks/permissions';
import { applicationConfig } from 'config/application_config';

import {
  MainContainer,
} from './style';

const DashboardHomePage = (): JSX.Element => {
  const permissions = usePermissions();
  const breadcrumbNavigator = useBreadcrumbNavigation();
  useRootPage({
    label: 'Painel',
    url: ROUTES.dashboard.root,
  });
  const { url } = useRouteMatch();

  const usersAction = () => breadcrumbNavigator.push({
    label: 'Usuários',
    url: `${url}${ROUTES.dashboard.users.root}`,
  });

  const clientsAction = () => breadcrumbNavigator.push({
    label: 'Clientes',
    url: `${url}${ROUTES.dashboard.clients.root}`,
  });

  const productsAction = () => breadcrumbNavigator.push({
    label: 'Produtos',
    url: `${url}${ROUTES.dashboard.products.root}`,
  });

  const inventoryAction = () => breadcrumbNavigator.push({
    label: 'Estoque',
    url: `${url}${ROUTES.dashboard.inventory.root}`,
  });

  const infrastructureAction = () => breadcrumbNavigator.push({
    label: 'Estrutura do viveiro',
    url: `${url}${ROUTES.dashboard.infrastructure.root}`,
  });

  return (
    <SectionBasePage title="Painel">
      <MainContainer>
        {permissions.checkRole(applicationConfig.roles.ROLE_ADMIN) && (
          <AccessCard title="Usuários" icon={<Icons.User />} action={usersAction} />
        )}
        <AccessCard title="Clientes" icon={<Icons.Client />} action={clientsAction} />
        <AccessCard title="Produtos" icon={<Icons.Development />} action={productsAction} />
        <AccessCard title="Estoque" icon={<Icons.Seed />} action={inventoryAction} />
        <AccessCard title="Estrutura do viveiro" icon={<Icons.House />} action={infrastructureAction} />
      </MainContainer>
    </SectionBasePage>
  );
};

export default DashboardHomePage;
